module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-12-08",
		"endpointPrefix": "acm",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "ACM",
		"serviceFullName": "AWS Certificate Manager",
		"signatureVersion": "v4",
		"targetPrefix": "CertificateManager",
		"uid": "acm-2015-12-08"
	},
	"operations": {
		"AddTagsToCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"CertificateArn",
					"Tags"
				],
				"members": {
					"CertificateArn": {},
					"Tags": {
						"shape": "S3"
					}
				}
			}
		},
		"DeleteCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"CertificateArn"
				],
				"members": {
					"CertificateArn": {}
				}
			}
		},
		"DescribeCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"CertificateArn"
				],
				"members": {
					"CertificateArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Certificate": {
						"type": "structure",
						"members": {
							"CertificateArn": {},
							"DomainName": {},
							"SubjectAlternativeNames": {
								"shape": "Sc"
							},
							"DomainValidationOptions": {
								"shape": "Sd"
							},
							"Serial": {},
							"Subject": {},
							"Issuer": {},
							"CreatedAt": {
								"type": "timestamp"
							},
							"IssuedAt": {
								"type": "timestamp"
							},
							"ImportedAt": {
								"type": "timestamp"
							},
							"Status": {},
							"RevokedAt": {
								"type": "timestamp"
							},
							"RevocationReason": {},
							"NotBefore": {
								"type": "timestamp"
							},
							"NotAfter": {
								"type": "timestamp"
							},
							"KeyAlgorithm": {},
							"SignatureAlgorithm": {},
							"InUseBy": {
								"type": "list",
								"member": {}
							},
							"FailureReason": {},
							"Type": {},
							"RenewalSummary": {
								"type": "structure",
								"required": [
									"RenewalStatus",
									"DomainValidationOptions"
								],
								"members": {
									"RenewalStatus": {},
									"DomainValidationOptions": {
										"shape": "Sd"
									}
								}
							}
						}
					}
				}
			}
		},
		"GetCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"CertificateArn"
				],
				"members": {
					"CertificateArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Certificate": {},
					"CertificateChain": {}
				}
			}
		},
		"ImportCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"Certificate",
					"PrivateKey"
				],
				"members": {
					"CertificateArn": {},
					"Certificate": {
						"type": "blob"
					},
					"PrivateKey": {
						"type": "blob",
						"sensitive": true
					},
					"CertificateChain": {
						"type": "blob"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CertificateArn": {}
				}
			}
		},
		"ListCertificates": {
			"input": {
				"type": "structure",
				"members": {
					"CertificateStatuses": {
						"type": "list",
						"member": {}
					},
					"NextToken": {},
					"MaxItems": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"CertificateSummaryList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"CertificateArn": {},
								"DomainName": {}
							}
						}
					}
				}
			}
		},
		"ListTagsForCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"CertificateArn"
				],
				"members": {
					"CertificateArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Tags": {
						"shape": "S3"
					}
				}
			}
		},
		"RemoveTagsFromCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"CertificateArn",
					"Tags"
				],
				"members": {
					"CertificateArn": {},
					"Tags": {
						"shape": "S3"
					}
				}
			}
		},
		"RequestCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {},
					"SubjectAlternativeNames": {
						"shape": "Sc"
					},
					"IdempotencyToken": {},
					"DomainValidationOptions": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"DomainName",
								"ValidationDomain"
							],
							"members": {
								"DomainName": {},
								"ValidationDomain": {}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CertificateArn": {}
				}
			}
		},
		"ResendValidationEmail": {
			"input": {
				"type": "structure",
				"required": [
					"CertificateArn",
					"Domain",
					"ValidationDomain"
				],
				"members": {
					"CertificateArn": {},
					"Domain": {},
					"ValidationDomain": {}
				}
			}
		}
	},
	"shapes": {
		"S3": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"Sc": {
			"type": "list",
			"member": {}
		},
		"Sd": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {},
					"ValidationEmails": {
						"type": "list",
						"member": {}
					},
					"ValidationDomain": {},
					"ValidationStatus": {}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/acm-2015-12-08.min.json
// module id = 1263
// module chunks = 0